<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="12">
          <!--<h6>Simple Form</h6>-->
          <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>

            <b-form-group label="Room Number" label-for="room_number">
              <b-form-input id="room_number" type="number" aria-describedby="liveFeedbackRoomNumber" v-model.lazy.trim="$v.form.room_number.$model" placeholder="Room Number" autofocus />
              <b-form-invalid-feedback id="liveFeedbackRoomNumber">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Bhent" label-for="price">
              <b-form-input id="price" type="number" aria-describedby="liveFeedbackPrice" v-model.lazy.trim="$v.form.price.$model" placeholder="Number of Beds" />
              <b-form-invalid-feedback id="liveFeedbackPrice">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Number of Beds" label-for="number_of_beds">
              <b-form-input id="number_of_beds" type="number" aria-describedby="liveFeedbackNumberOfBeds" v-model.lazy.trim="$v.form.number_of_beds.$model" placeholder="Number of Beds" />
              <b-form-invalid-feedback id="liveFeedbackNumberOfBeds">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Max Occupiers" label-for="max_occupiers">
              <b-form-input id="max_occupiers" type="number" aria-describedby="liveFeedbackMaxOccupiers" v-model.lazy.trim="$v.form.max_occupiers.$model" placeholder="Max Occupiers" />
              <b-form-invalid-feedback id="liveFeedbackMaxOccupiers">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Has Toilet?" label-cols-sm="4" label-cols-lg="3">
              <b-form-radio-group v-model="$v.form.has_toilet.$model" class="pt-2" :state="chkState('has_toilet')">
                <b-form-radio value="1">Yes</b-form-radio>
                <b-form-radio value="0">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group label="Has AC?" label-cols-sm="4" label-cols-lg="3">
              <b-form-radio-group v-model="$v.form.has_ac.$model" class="pt-2" :state="chkState('has_ac')">
                <b-form-radio value="1">Yes</b-form-radio>
                <b-form-radio value="0">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-button type="submit" variant="primary" :disabled="$v.form.$invalid">
              Submit
            </b-button>
            <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
          </b-form>
          <br />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
  mapActions
} from 'vuex'
import {
  required
} from "vuelidate/lib/validators"

const formShape = {
  room_number: "",
  price: 0,
  number_of_beds: null,
  max_occupiers: null,
  has_toilet: null,
  has_ac: null
}

export default {
  name: "RoomFormEdit",
  props: {
    room: Object
  },
  data() {
    return {
      form: Object.assign({}, formShape),
      submitted: false
    }
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isDirty() {
      return this.$v.form.$anyDirty
    }
  },
  validations: {
    form: {
      room_number: {
        required
      },
      price: {
        required
      },
      number_of_beds: {
        required
      },
      max_occupiers: {
        required
      },
      has_toilet: {
        required
      },
      has_ac: {
        required
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          this.submitted = true
          let params = {
            building_id: this.$route.params.building_id,
            floor_id: this.$route.params.floor_id,
            room_id: this.room.id,
            room_number: this.$v.form.room_number.$model,
            price: this.$v.form.price.$model,
            number_of_beds: this.$v.form.number_of_beds.$model,
            max_occupiers: this.$v.form.max_occupiers.$model,
            has_toilet: this.$v.form.has_toilet.$model,
            has_ac: this.$v.form.has_ac.$model,
          }

          this.$store.dispatch('rooms/editRoom', params)
            .then(() => {
              this.$emit('success')
              this.showSuccessMsg()
            })
            .catch((error) => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg()
              }
            })
        })
      }
    },
    onCancel() {
      this.$emit('cancel')
    },
    onReset() {
      // Reset validation
      this.form = formShape
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    chkState(val) {
      const field = this.$v.form[val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  },
  beforeMount() {
    this.form.room_number = this.room.room_number
    this.form.price = this.room.price
    this.form.number_of_beds = this.room.number_of_beds
    this.form.max_occupiers = this.room.max_occupiers
    this.form.has_toilet = this.room.has_toilet.toString()
    this.form.has_ac = this.room.has_ac.toString()
  }
}
</script>
